export default __webpack_public_path__ + "static/media/teamwork.a51c0170.png";